import script from "./tasks-modal.vue?vue&type=script&setup=true&lang=js"
export * from "./tasks-modal.vue?vue&type=script&setup=true&lang=js"

import "./tasks-modal.vue?vue&type=style&index=0&id=2e85305e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e85305e"]])

export default __exports__